import makeBehaviorSubject from 'callbag-behavior-subject';
import {ApiService} from '../api';
import {ShopifyProduct, ShopifyVariant} from '../../interfaces/shopify-product.interface';
import {ShoppingCartUtils} from '../../utils/shopping-cart_utils';
import {EventType} from '../../interfaces/shopping-cart.interface';

export class ShopifyService extends ApiService {
  productVariantsSubject: makeBehaviorSubject<object>;
  selectedProductSubject: makeBehaviorSubject<ShopifyVariant>;
  selectedVariantValueSubject: makeBehaviorSubject<string>;
  private product: ShopifyProduct = null;
  private readonly selectedProductOptions: Pick<ShopifyVariant, 'option1' | 'option2' | 'option3'>;

  constructor() {
    super();
    this.productVariantsSubject = makeBehaviorSubject(this.selectedProductOptions);
    this.selectedProductSubject = makeBehaviorSubject(null);
    this.selectedVariantValueSubject = makeBehaviorSubject('');
    this.selectedProductOptions = {option1: null, option2: null, option3: null};
  }

  updateProductVariant(variantName: string, variantValue: string) {
    this.selectedProductOptions[variantName] = variantValue;
    this.selectedVariantValueSubject(EventType.Data, variantValue);
    this.productVariantsSubject(EventType.Data, this.selectedProductOptions);
    this.getSelectedVariant();
  }

  updateProductData(product: ShopifyProduct) {
    this.product = product;
    this.getSelectedVariant();
  }

  private getSelectedVariant() {
    if (!this.product) {
      return;
    }
    const imagesIds = this.product.product_images.map(image => image.shopify_id).join(',');
    let selectedVariant = this.product.variants.filter(variant => {
      return ShoppingCartUtils.isMatchingVariant(this.selectedProductOptions, variant);
    });

    if (!selectedVariant.length && this.selectedProductOptions.option1) {
      selectedVariant = this.product.variants
        .filter((variant: ShopifyVariant) => variant.option1 === this.selectedProductOptions.option1)
        .filter((variant: ShopifyVariant) => imagesIds.includes(`${variant.image_id}`));
    }

    if (!selectedVariant.length) {
      selectedVariant = [{...this.product.variants[0], isAutoSelected: true} as ShopifyVariant];
    }

    this.selectedProductSubject(EventType.Data, selectedVariant[0]);
  }
}
